import { Chess, type PieceSymbol } from "chess.js";
import { replay, type PlayedMove, START_FEN } from "./game";

/** Human move numbers, including games beginning with Black or a later move. */
export function replayPosition(ply: number, startFen = START_FEN) {
  if (ply <= 0) return { label: "Start", description: "Starting position" };
  const fields = startFen.split(" ");
  const slot = ply - 1 + (fields[1] === "b" ? 1 : 0);
  const number = Number(fields[5]) + Math.floor(slot / 2);
  const side = slot % 2 ? "Black" : "White";
  return { label: `Move ${number}`, description: `After ${side}’s move ${number}` };
}

/** Use actual capture history so promotions and en passant remain accurate. */
export function capturedPieces(startFen: string, moves: PlayedMove[]) {
  const chess = replay(startFen, moves.map((move) => move.uci));
  const captures: Record<"w" | "b", PieceSymbol[]> = { w: [], b: [] };
  for (const move of chess.history({ verbose: true })) if (move.captured) captures[move.color].push(move.captured);
  const order = "qrbnp";
  for (const color of ["w", "b"] as const) captures[color].sort((a, b) => order.indexOf(a) - order.indexOf(b));
  return captures;
}

export function moveDescription(fen: string, san: string) {
  const move = new Chess(fen).move(san);
  const names = { p: "Pawn", n: "Knight", b: "Bishop", r: "Rook", q: "Queen", k: "King" };
  if (move.isKingsideCastle()) return "Castle kingside";
  if (move.isQueensideCastle()) return "Castle queenside";
  return `${names[move.piece]} to ${move.to}${move.san.includes("#") ? " · Checkmate" : move.san.includes("+") ? " · Check" : ""}`;
}
